import { Controller, useFormContext } from 'react-hook-form';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import FormDateField from 'common/form-date-field';
import FormSelectField from 'common/form-select-field';
import FormTextField from 'common/form-text-field';

import { AssignedTaskMatterInfoType } from './assigned-task-matter-info';
import AssignedTaskMatterInfoTrustadminGrantorsForm from './assigned-task-matter-info-trustadmin-grantors-form';
import AssignedTaskMatterInfoTrustadminTrusteesForm from './assigned-task-matter-info-trustadmin-trustees-form';

const useStyles = makeStyles(() => ({
  headerText: {
    display: 'flex',
    alignItems: 'center',
  },
  columnHeader: {
    width: '250px',
  },
  column: {
    display: 'flex',
    width: '100%',
    padding: '20px 0',
    borderBottom: '1px solid #ECEEF1',
    alignItems: 'center',
  },
  columnBody: {
    display: 'flex',
    flex: 1,
  },
  fieldRequired: {
    color: 'red',
  },
}));

const AssignedTaskMatterInfoTrustadminForm = () => {
  const classes = useStyles();

  const {
    formState: { errors },
    control,
  } = useFormContext<AssignedTaskMatterInfoType>();

  return (
    <>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>
            <span className={classes.fieldRequired}>*</span> Trust Name
          </Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTrustadminFields.trustName"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                autoFocus
                errorMessage={errors.estateTrustadminFields?.trustName?.message}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>Trust Date</Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTrustadminFields.trustDate"
            control={control}
            render={({ field: { onChange, value, name } }) => (
              <FormDateField {...{ value, onChange, name }} />
            )}
          />
        </div>
      </div>
      <AssignedTaskMatterInfoTrustadminGrantorsForm />
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>
            Is it a grantor trust or non-grantor trust?
          </Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTrustadminFields.isGrantorTrust"
            control={control}
            render={({ field: { ref, value, onChange, ...field } }) => (
              <FormSelectField
                {...field}
                value={value === true ? 'yes' : 'no'}
                onChange={(e) => onChange(e.target.value === 'yes')}
                inputRef={ref}
                options={[
                  {
                    label: 'Grantor Trust',
                    value: 'yes',
                  },
                  {
                    label: 'Non-Grantor Trust',
                    value: 'no',
                  },
                ]}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>
            Is it a revocable trust or irrevocable trust?
          </Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTrustadminFields.isRevocableTrust"
            control={control}
            render={({ field: { ref, value, onChange, ...field } }) => (
              <FormSelectField
                {...field}
                value={value === true ? 'yes' : 'no'}
                onChange={(e) => onChange(e.target.value === 'yes')}
                inputRef={ref}
                options={[
                  {
                    label: 'Revocable Trust',
                    value: 'yes',
                  },
                  {
                    label: 'Irrevocable Trust',
                    value: 'no',
                  },
                ]}
              />
            )}
          />
        </div>
      </div>
      <div className={classes.column}>
        <div className={classes.columnHeader}>
          <Typography className={classes.headerText}>
            If trust is not using grantor SSN and has a separate EIN, list it here.
          </Typography>
        </div>
        <div className={classes.columnBody}>
          <Controller
            name="estateTrustadminFields.ein"
            control={control}
            render={({ field: { ref, ...field } }) => (
              <FormTextField
                {...field}
                inputRef={ref}
                helperText="If you have not yet obtained an EIN, leave this field blank."
              />
            )}
          />
        </div>
      </div>
      <AssignedTaskMatterInfoTrustadminTrusteesForm />
    </>
  );
};

export default AssignedTaskMatterInfoTrustadminForm;
